var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCloseWhite = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5198 12.853C12.3244 13.0484 12.0082 13.0484 11.8126 12.853L7.66663 8.70613L3.51976 12.853C3.32435 13.0484 3.0082 13.0484 2.81257 12.853C2.61716 12.6576 2.61716 12.3414 2.81257 12.1458L6.96038 7.99988L2.8132 3.85301C2.61779 3.6576 2.61779 3.34145 2.8132 3.14582C3.0086 2.95042 3.32476 2.95042 3.52038 3.14582L7.66663 7.29363L11.8135 3.14676C12.0089 2.95135 12.3251 2.95135 12.5207 3.14676C12.7161 3.34217 12.7161 3.65832 12.5207 3.85395L8.37288 7.99988L12.5198 12.1468C12.7166 12.3405 12.7166 12.6593 12.5198 12.853Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCloseWhite);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/close_white.50bb3c5fee753bd380788a88b4c76bae.svg";